import MealPlanPoster from "../../../../../images/posters/avatar/app/meal-plan.webp";
import AdjustGoalPoster from "../../../../../images/posters/avatar/app/adjust-goal.webp";
import WaterWeightPoster from "../../../../../images/posters/avatar/app/water-weight.webp";
import VacationPoster from "../../../../../images/posters/avatar/app/vacation.webp";
import DailyWeightsPoster from "../../../../../images/posters/avatar/app/daily-weights.webp";
import TurnOffFastingPoster from "../../../../../images/posters/avatar/app/turn-on-intermittent-fasting.webp";
import ScanningPoster from "../../../../../images/posters/avatar/app/scanning.webp";
import ResetProfilePoster from "../../../../../images/posters/avatar/app/reset-profile.webp";
import RecipePoster from "../../../../../images/posters/avatar/app/recipe.webp";
import AdjustProteinPoster from "../../../../../images/posters/avatar/app/adjust-protein.webp";
import MenstrualQuestionPoster from "../../../../../images/posters/avatar/app/menstrual-question.webp";
import CopySaveMealPoster from "../../../../../images/posters/avatar/app/copy-save-meal.webp";
import EnterDailyWeightPoster from "../../../../../images/posters/avatar/app/enter-daily-weight.webp";
import UseIntermittentFastingPoster from "../../../../../images/posters/avatar/app/use-intermittent-fasting.webp";
import HighLowDaysPoster from "../../../../../images/posters/avatar/app/high-low-days.webp";
import ChangeGoalPoster from "../../../../../images/posters/avatar/app/change-goal.webp";
import FavoritesPoster from "../../../../../images/posters/avatar/app/favorites.webp";
import DietRestrictionsPoster from "../../../../../images/posters/avatar/app/diet-restrictions.webp";
import DailyMacroAdjustmentsPoster from "../../../../../images/posters/avatar/app/daily-macro-adjustments.webp";
import AddCustomItemPoster from "../../../../../images/posters/avatar/app/add-custom-item.webp";
import EditCheckInPoster from "../../../../../images/posters/avatar/app/edit-check-in.webp";
import ChangeCheckInDayPoster from "../../../../../images/posters/avatar/app/change-check-in-day.webp";
import CheckInComponentsPoster from "../../../../../images/posters/avatar/app/check-in-components.webp";
import CarbFatAdjustmentPoster from "../../../../../images/posters/avatar/app/carb-fat-adjustment.webp";
import CantHitProteinPoster from "../../../../../images/posters/avatar/app/cant-hit-protein.webp";
import BodyFatPoster from "../../../../../images/posters/avatar/app/body-fat.webp";
import AveragesPoster from "../../../../../images/posters/avatar/app/averages.webp";
import AlcoholPoster from "../../../../../images/posters/avatar/app/alcohol.webp";
import SearchFoodPoster from "../../../../../images/posters/avatar/app/search-food.webp";
import ActivityLevelPoster from "../../../../../images/posters/avatar/app/activity-level.webp";
import FriendsPoster from "../../../../../images/posters/avatar/app/friends.webp";
import PauseYourGoalPoster from "../../../../../images/posters/avatar/app/pause-your-goal.webp";
import PracticeModePoster from "../../../../../images/posters/avatar/app/practice-mode.webp";

const avatarAppVideos = [
  {
    "title": "Generating a Meal Plan",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Creating+a+Meal+Plan.mp4",
    "thumbnail": MealPlanPoster,
    "objectFit": "contain",
    "length": "6:02"
  },
  {
    "title": "When to Adjust Your Goal",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/when+should+i+adjust+goal.mp4",
    "thumbnail": AdjustGoalPoster,
    "objectFit": "contain",
    "length": "0:33"
  },
  {
    "title": "How Water Weight is Considered",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Water+Weight.mp4",
    "thumbnail": WaterWeightPoster,
    "objectFit": "contain",
    "length": "1:00"
  },
  // {
  //   "title": "Vacation Mode",
  //   "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/vacation+mode.mp4",
  //   "thumbnail": VacationPoster,
  //   "objectFit": "contain",
  //   "length": "0:54"
  // },
  {
    "title": "How to Turn on Daily Weights",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/turning+on+daily+weights.mp4",
    "thumbnail": DailyWeightsPoster,
    "objectFit": "contain",
    "length": "0:30"
  },
  {
    "title": "Turning Off Intermittent Fasting Timer",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/turn+off+fasting.mp4",
    "thumbnail": TurnOffFastingPoster,
    "objectFit": "contain",
    "length": "0:21"
  },
  {
    "title": "Scanning Bar Codes",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Scanner.mp4",
    "thumbnail": ScanningPoster,
    "objectFit": "contain",
    "length": "0:18"
  },
  {
    "title": "Resetting Your Profile",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/reset+profile.mp4",
    "thumbnail": ResetProfilePoster,
    "objectFit": "contain",
    "length": "0:30"
  },
  {
    "title": "Creating a Recipe",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Recipes.mp4",
    "thumbnail": RecipePoster,
    "objectFit": "contain",
    "length": "0:48"
  },
  {
    "title": "Adjusting Protein",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/protein+adjustment.mp4",
    "thumbnail": AdjustProteinPoster,
    "objectFit": "contain",
    "length": "0:26"
  },
  {
    "title": "Turning on the Menstrual Question for Check-ins",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Menstrual+Question.mp4",
    "thumbnail": MenstrualQuestionPoster,
    "objectFit": "contain",
    "length": "0:24"
  },
  {
    "title": "Copying and Saving Meals",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Meal+Controls.mp4",
    "thumbnail": CopySaveMealPoster,
    "objectFit": "contain",
    "length": "0:32"
  },
  {
    "title": "How to Enter Your Daily Weight",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Log+Daily+Weight.mp4",
    "thumbnail": EnterDailyWeightPoster,
    "objectFit": "contain",
    "length": "0:21"
  },
  {
    "title": "How to Use the Intermittent Fasting Feature",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/intermittent+fasting.mp4",
    "thumbnail": UseIntermittentFastingPoster,
    "objectFit": "contain",
    "length": "0:50"
  },
  {
    "title": "High/Low Days",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/high+low+days.mp4",
    "thumbnail": HighLowDaysPoster,
    "objectFit": "contain",
    "length": "0:30"
  },
  {
    "title": "How to Change Your Goal",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/goal+changes.mp4",
    "thumbnail": ChangeGoalPoster,
    "objectFit": "contain",
    "length": "0:44"
  },
  {
    "title": "Favorites",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Favorites.mp4",
    "thumbnail": FavoritesPoster,
    "objectFit": "contain",
    "length": "0:17"
  },
  {
    "title": "Changing Diet Restrictions",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Diet+Restrictions.mp4",
    "thumbnail": DietRestrictionsPoster,
    "objectFit": "contain",
    "length": "0:22"
  },
  {
    "title": "Daily Macro Adjustments",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/daily+macro+adjustments.mp4",
    "thumbnail": DailyMacroAdjustmentsPoster,
    "objectFit": "contain",
    "length": "0:50"
  },
  {
    "title": "Adding an Item with Custom Macros",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Custom+Add.mp4",
    "thumbnail": AddCustomItemPoster,
    "objectFit": "contain",
    "length": "0:39"
  },
  {
    "title": "Editing Check-ins and Adding Photos or Measurements",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Check+in+edits+photos+measurements.mp4",
    "thumbnail": EditCheckInPoster,
    "objectFit": "contain",
    "length": "1:11"
  },
  {
    "title": "How to Change Check in Day",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/check+in+day.mp4",
    "thumbnail": ChangeCheckInDayPoster,
    "objectFit": "contain",
    "length": "0:15"
  },
  {
    "title": "Check In Components",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Check+in+Components.mp4",
    "thumbnail": CheckInComponentsPoster,
    "objectFit": "contain",
    "length": "0:53"
  },
  {
    "title": "Carb and Fat Adjustment",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/carbs+and+fat+adjustment.mp4",
    "thumbnail": CarbFatAdjustmentPoster,
    "objectFit": "contain",
    "length": "0:29"
  },
  {
    "title": "What to Do When You Can't Hit Protein",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/cant+hit+protein.mp4",
    "thumbnail": CantHitProteinPoster,
    "objectFit": "contain",
    "length": "0:54"
  },
  {
    "title": "Body Fat",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Body+Fat.mp4",
    "thumbnail": BodyFatPoster,
    "objectFit": "contain",
    "length": "0:55"
  },
  {
    "title": "Averages",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Averages.mp4",
    "thumbnail": AveragesPoster,
    "objectFit": "contain",
    "length": "0:24"
  },
  {
    "title": "Alcohol Tracking",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Alcohol+Tracking.mp4",
    "thumbnail": AlcoholPoster,
    "objectFit": "contain",
    "length": "0:28"
  },
  {
    "title": "Searching for a Food",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Adding+an+item.mp4",
    "thumbnail": SearchFoodPoster,
    "objectFit": "contain",
    "length": "0:43"
  },
  {
    "title": "Changing Activity Level",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/activity+level.mp4",
    "thumbnail": ActivityLevelPoster,
    "objectFit": "contain",
    "length": "0:31"
  },
  {
    "title": "Friends",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Friends.mp4",
    "thumbnail": FriendsPoster,
    "objectFit": "contain",
    "length": "9:55"
  },
  {
    "title": "Pause Your Goal",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Turn+on+Pause+Goal.mp4",
    "thumbnail": PauseYourGoalPoster,
    "objectFit": "contain",
    "length": "1:18"
  },
  {
    "title": "Practice Mode",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/avatar/app/Turn+on+Practice+Mode.mp4",
    "thumbnail": PracticeModePoster,
    "objectFit": "contain",
    "length": "1:25"
  }
];

export default avatarAppVideos; 